<template>
	<section v-if="type == 'airport'">
		<div class="airport_top">
			<p style="font-size:25px !important;">爆款机票，火热预约！</p>
			<p style="font-weight: bold !important;font-size:12px !important;">（请广大旅客及时关注，每天更新不同航线预约报价供您挑选！）</p>
		</div>
		<div class="airport_center" v-for="(update,key,index) in upDateList">


			<p style="font-weight: bold !important;color: #6699D8">更新时间：{{update}}</p>
			<table style="width: 96%;margin: 0 2% 0 2%;border:solid 2px #DDDDDD;" cellpadding="10" cellspacing="10" border="solid 2px #DDDDDD">
				<th colspan="6" style="background: #548DD4;color: white;font-weight: bold;width: 100%;">国内航线</th>

				<tr style="font-weight: bold;">
					<td>到达 - 出发</td>
					<td>类型</td>
					<td>价格</td>
					<td>车票</td>
					<td>详情</td>
				</tr>

				<tr v-for="(item, index) in FlightList" :key="item.ID" v-if="item.CreateDate.indexOf(update)!=-1">
					<td>{{ item.ScopeName }}</td>
					<td>{{ item.IsPickup == false ? '单程' : '往返' }}</td>
					<td>¥{{ item.AdultPrice }}</td>
					<td>{{ item.Remarks }}</td>
					<td v-on:click="appointment(item.ID)" style="font-weight: bold;color: #576B95;">预约</td>
				</tr>
			</table>










		</div>
		<div class="airport_bottom">
<!-- 			<div class="airport_bottom_border">
				<p style="font-size: 20px !important;color:#748D9A;font-weight: bold;margin-bottom: 10px;">预约步骤</p>

				<div style="display: flex;flex-wrap: wrap;justify-content: center;text-align: center;">
					<img src="../assets/1.png" style="width: 50%;" />
					<img src="../assets/2.png" style="width: 50%;" />
					<p style="font-size: 16px !important;color:#79919E;font-weight: bold;width:100%;">公众号可直接进入界面</p>
					<p style="font-size: 16px !important;color:#79919E;font-weight: bold;width:100%;">感兴趣的航线可点击预约</p>
					<img src="../assets/3.png" style="width: 50%;" />
					<img src="../assets/4.png" style="width: 50%;" />
					<p style="font-size: 16px !important;color:#79919E;font-weight: bold;width:100%;">查看产品详情</p>
					<p style="font-size: 16px !important;color:#79919E;font-weight: bold;width:100%;">合适产品可填写客人信息进行提交预约</p>
					<p style="font-size: 16px !important;color:#79919E;font-weight: bold;width:100%;">后续会有客服人员联系回复报价进行订票</p>
				</div>
			</div> -->

			<p style="font-size: 16px !important;color:black;font-weight: bold;text-align: center;">咨询热线：0760-88880777</p>
			<p style="font-size: 16px !important;color:black;font-weight: bold;text-align: center;">地址：中山市西区翠峰路6号懿峯国际广场首层</p>
		</div>
	</section>
	<section v-else-if="type == 'hotel'">hotel</section>
	<section v-else-if="type == 'ticket'">ticket</section>
	<section v-else-if="type == 'travel'">travel</section>
</template>

<script>
import shop from '../request/scopeApi.js';
export default {
	name: 'shopTypePage',
	data() {
		return {
			type: '',

			FlightList: [],
      upDateList:[],
		};
	},
	activated: function() {
		if (this.$route.params.type && this.$route.params.type.length) {
			// console.log(this.$route.params)
			this.type = this.$route.params.type;
		}

		this.getFligtShopList();
	},
	components: {},
	mounted() {
		document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
		// document.querySelector('body').setAttribute('style', 'height:100%');
	},
	methods: {
		appointment(typeid) {
			// console.log(typeid)
			this.$router.push({
				name: 'shopFlightDetail',
				params: {
					type: typeid
				}
			});
		},
		getFligtShopList() {
      var that = this;
			var infoid = '';
			if (this.type == 'airport') {
				infoid = 1;
			}
			// else if(){}
			shop.getFlightShopList(infoid).then(res => {
				if (res.success && res.data.length > 0) {
          console.log(res.data)
					this.FlightList = res.data;
          this.FlightList.forEach(obj=>{
            let tmpDate=obj.CreateDate.split('T')[0];
            if(that.upDateList.indexOf(tmpDate)==-1){
              that.upDateList.unshift(tmpDate);
            }
          })
				}
			});
		}
	}
};
</script>

<style>
/*  ::-webkit-scrollbar {
    display: none;
  } */

.airport_top {
	text-align: center;
	color: #6699d8;
	padding: 10px 0 0 0;
}

.airport_center {
	text-align: center;
	margin: 15px 0 30px 0;
}

.airport_center td {
	padding: 10px;
}

.airport_bottom {
	width: 94%;
	margin: 0 3% 20px 3%;
}

.airport_bottom_border {
	padding: 10px;
	border: solid 2px #b1cedf;
	box-shadow: #b1cedf 2px;
	border-radius: 10px;
	margin: 0 0 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shopTypePage.vue